<template>
  <Text
    v-if="data.text"
    :text="data.text"
  />
</template>

<script setup lang="ts">
defineProps<{
  data: object
}>()
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.text {
  @include tools.page-grid-columns;

  p,
  ol,
  ul {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
